<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left> 赛事督导详细信息 </template>
    <template v-slot:nav_right v-if="supervisionInfo.supervisorySignatoriesUuids">
      <div  class="yioks_btn" @click="download">下载赛事督导评估表</div>
      <!--<div  class="yioks_btn" @click="isUploadMatch = true" v-if="userRole === 'expert'">签字并上传赛事督导评估表</div>-->
      <!--<div  class="yioks_btn" v-if="['admin','system'].includes(userRole) && supervisionInfo.fileUrl" @click="lookFile">查看赛事督导评估表</div>-->
    </template>
    <div v-if="!isLoading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item">
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>单位：{{supervisionInfo.organShortName}}-{{supervisionInfo.youthShortName}}</span>
                <span>比赛名称 ：{{supervisionInfo.matchName}}</span>
              </div>
              <div class="col">
                <span>比赛时间：{{ supervisionInfo.matchTime  | time}}</span>
                <span>赛区名称 ：{{supervisionInfo.matchTitle}}</span>
              </div>
              <div class="col">
                <span>组别：{{supervisionInfo.matchGroup || '--'}}</span>
                <span>球队名称：{{supervisionInfo.squadName}}</span>
                
              </div>
              <div class="col">
                <span>教练员 ：{{supervisionInfo.trainCoach || '无'}}
                  <template v-if="!supervisionInfo.trainCoach">
                    （备注：{{supervisionInfo.otherCoach || '--'}}）
                  </template>
                </span>
                <span>总分：{{supervisionInfo.totalScore}} 分</span>
              </div>
              <div class="col" v-if="supervisionInfo.trainCoach">
                <span>备注：{{supervisionInfo.otherCoach || '--'}}</span>
              </div>
              <div class="trainPlan">
                <div class="planDetail">
                  <div class="info">
                    <p> 球队管理 (满分40分)</p>
                    <p> {{squadScore}}分 </p>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">重视程度</p>
                      <p class="content">{{supervisionInfo.squadDegreeAttention}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">赛风赛纪</p>
                      <p class="content">{{supervisionInfo.squadDiscipline}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">按时到达</p>
                      <p class="content">{{supervisionInfo.squadArrive}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">服装统一</p>
                      <p class="content">{{supervisionInfo.squadUniformCostumes}}分</p>
                    </div>
                  </div>
                </div>
                <div class="planDetail">
                  <div class="info">
                    <p>执教能力 (满分60分)</p>
                    <p>{{coachScore}}分</p>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">战术安排</p>
                      <p class="content">{{supervisionInfo.coachTactics}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">观察指导</p>
                      <p class="content">{{supervisionInfo.coachObservational}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">应变调整</p>
                      <p class="content">{{supervisionInfo.coachStrainAdjustment}}分</p>
                    </div>
                  </div>
                  <div class="box-wrap">
                    <div class="box">
                      <p class="indicatorName">队员技术</p>
                      <p class="content">{{supervisionInfo.coachPlayerTactics}}分</p>
                    </div>
                  </div>
                </div>
              </div>
              <fieldset class="vita-form-fieldset" style="border: 1px dashed white;padding: 10px ; margin: 0 15px 15px;">
                <legend></legend>
                <div class="col titleAndInfo">
                  <span class="titleTitle">执教现状及问题分析：</span>
                  <span>{{supervisionInfo.coachBaseStatus}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span class="titleTitle">执教工作亮点及值得推广的措施：</span>
                  <span>{{supervisionInfo.workHighlights}}</span>
                </div>
                <div class="col">
                  <span class="titleTitle">反馈建议：</span>
                  <span>{{supervisionInfo.questionsSuggestions}}</span>
                </div>
              </fieldset>
              <div class="col">
                <span>填写人 ：{{supervisionInfo.trainSupervisory}}</span>
                <span>填写日期 ：{{supervisionInfo.writeTime | time}}</span>
              </div>
              <div class="col">
                <span>签字人 ：{{supervisionInfo.supervisorySignatories || '--'}}</span>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <yioks-loading v-if="isLoading"></yioks-loading>
    <template v-if="isUploadMatch">
      <upload-dialog-match
        :isOpenMatch.sync="isUploadMatch"
        :isEdit="isEditModeMatch"
        :supervisionUuid="supervisionUuid"
        @closeDialogCallBackSupervisionMatch="handleUploadCallBack"
      ></upload-dialog-match>
    </template>
  </SubContent>
</template>

<script>
import supervision from "@/api/supervision"; // getPlayerInfo获取球员信息
import storage from "@/utils/storage";
import common from '@/api/common'
import {  squadPlayerSex } from '@/utils/yioks_filter'
import playImg from '@/assets/images/common/playImg.png'

export default {
  name: "ScoutRate",

  data() {
    return {
      playImg,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      isLoading: true,
      supervisionInfo: {},
      isUploadMatch: false,
      isEditModeMatch: false,
      downIng: false,
    };
  },

  components: {
    SubContent: () => import("@/components/layout/newSubContent"),
    "upload-dialog-match": () => import("@/views/supervisory/uploadSupervisionMatchReport"),
  },

  computed: {
    supervisionUuid() {
      const uuid = this.$route.query.supervisionUuid || "";
      return uuid;
    },
    squadScore() {
      const scores = [
        this.supervisionInfo.squadDegreeAttention,
        this.supervisionInfo.squadDiscipline,
        this.supervisionInfo.squadArrive,
        this.supervisionInfo.squadUniformCostumes
      ];
      return scores.reduce((sum, score) => sum + Number(score), 0);
    },
    coachScore() {
      const scores = [
        this.supervisionInfo.coachTactics,
        this.supervisionInfo.coachObservational,
        this.supervisionInfo.coachStrainAdjustment,
        this.supervisionInfo.coachPlayerTactics
      ];
      return scores.reduce((sum, score) => sum + Number(score), 0);
    },
  },

  filters: {
    squadPlayerSex
  },

  mounted() {
    this.loadSupervisoryInfo();
  },

  methods: {
    download () {
      if (this.downIng) return
      this.downIng = true
      supervision.supervisoryMatchDownLoadPdf({ dataUuid: this.supervisionUuid }).then(res => {
        const { fileName, filePath } = res
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    // 提交弹窗回掉方法
    handleUploadCallBack(dialogStatus, confirmStatus) {
      this.isUploadMatch = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          this.isEditModeMatch = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
      }
    
    },
    /* 获取球探报告详细信息 */
    loadSupervisoryInfo() {
      const uuid = this.supervisionUuid;
      supervision
        .getMatchSupervisoryInfo(uuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return
          }
          this.supervisionInfo = res;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error("异常", err);
        });
    },
    lookFile(){
      if (this.supervisionInfo.fileUrl) {
        window.open('http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent(this.$Base64.encode(this.supervisionInfo.fileUrl)));
      }else{
        this.$message.error('评估表暂未上传');
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
.nav-right-btn
  font-size 18px
  padding 10px 15px
  display -webkit-box
  display -ms-flexbox
  display flex
  -webkit-box-align center
  -ms-flex-align center
  align-items center
  cursor pointer
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none
  margin-right 10px
  border 1px solid #fff
  &:hover
    background-color #4cd964
    border 1px solid #4cd964
.record-dialog
  color #000
  .title-text
    color #000
    font-size 24px
    border-bottom 1px solid #666
    padding-bottom 10px
.time-line-wrapper
  padding 0 15px
  .time-item
    display flex
    justify-content center
    align-items center
    margin-bottom 20px
    position relative
    &:first-child
      .line
        border-left none
    .line
      height 59%
      border-left 2px solid #666
      position absolute
      top -34px
      left 25px
    .item-left
      width 50px
      height 50px
      display flex
      justify-content center
      align-items center
      border-radius 50%
      border 1px solid #666
      text-align center
    .item-right
      font-size 16px
      width 90%
      margin-left 20px
      .time-content
        text-indent 2px
      .item-info
        min-height 62px
        border-radius 5px
        border 1px solid #ccc
        padding 12px
.focus-action-tips
  .tips-title-wrapper
    color #000
    font-size 24px
    padding-bottom 10px
    border-bottom 1px solid #666
  .focus-action-content
    font-size 16px
  .tips-text
    margin-bottom 10px
    display flex
    align-items center
  .footer-btns-wrapper
    width 60%
    margin 0 auto
    display flex
    justify-content space-around
    font-size 16px
.yioks-outline:focus
  outline-color #4cd964 !important
  border-color #4cd964 !important
.scroll_wrap {
  height: 100%;
  padding: 20px 0 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .info_item {
    margin: 0 30px 30px 10px;
    .info_title {
      font-size: 20px;
      padding: 10px 0 20px;
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
        width: 26px;
      }
    }

    .base_info {
      border: 1px solid #FFF;
      display: flex;
      position relative
      .focus-tips{
        position absolute
        top 0
        right 0
        width 100px
        height 100px
        overflow hidden
        .tips-content{
          width 150px
          height 20px
          line-height 20px
          text-align center
          background-color red
          transform rotate(45deg)
          position absolute
          top 21px
          right -46px
        }
      }
      .info {
        flex: 1;
      }

      .col {
        /*border-bottom: 1px solid #FFF;*/
        // border-right 1px solid #FFF
        padding: 16px 15px;
        display: flex;
        justify-content: space-around;

        span {
          display: inline-block;
          width: 100%;
        }
        .titleTitle{
          width:53%
        }
        .titleTitleSquad{
          width:50%
        }

       /* &:last-child {
          border-bottom: 0;
        }*/
      }
      .titleAndInfo{
        border-bottom:1px dashed #FFF
      }
      .playerImg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 120px;
          height: 120px;
          /* height 1.2rem */
          border-radius: 50%;
          padding: 10px;
        }

        p {
          text-align: center;
        }
      }
    }
  }
  .item_title{
    display flex
    align-items center
    font-size .2rem
    padding .4rem 0 .2rem
    margin 0 .3rem
    span{
      margin-left .4rem
      font-size .16rem
    }
    img{
      margin-right .1rem
    }
  }
  .trainPlan{
    display flex
    justify-content space-between
    flex-wrap wrap
    /*margin:0 .3rem;*/
    .planDetail{
      margin: 0 15px 15px
      border 1px dashed white
      width 100%
      .row{
        min-height 49px
        display flex
        align-items center
        border-bottom 1px solid white
        &:last-child{
          border-bottom none
        }
        .col{
          width:50%
          padding 0 10px 0 20px
          height 100%
          line-height 49px
          text-overflow:ellipsis;
          overflow:hidden;
          white-space:nowrap;
          &:first-child{
            border-right 1px solid white
          }
        }
      }
      .rowLine{
        padding:10px 10px 10px 20px
      }
    }
    .mediaDetail{
      background-color rgba(0, 0, 0, 0.7)
      border 1px solid white
      padding 20px
      width 400px
      display flex
      align-items center
      cursor pointer
      margin-bottom 20px
      .p_item{
        margin-bottom 10px
      }
    }
    .img{
      width 170px
      height 100px
      position relative
      .coverImg{
        width 100%
        height 100%
      }
    }
    .intro{
      padding-left 10px
      width:calc(100% - 170px);
      height 100px
      display flex
      flex-direction column
      justify-content space-between
    }
  }
}

.trainPlan {
  .planDetail {
    border: 1px solid white;
    width: 100%;
    display: flex;
    margin-bottom: 15px;

    .info {
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-right: 1px dashed #FFF;

      p {
        padding-top: 10px;
      }

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }

    .box-wrap {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    //   justify-content: space-around;
      justify-content: flex-start;
      padding: 10px 5px 0;

      .box {
        width: 90px;
        display: flex;
        margin: 0 10px 10px
        flex-direction: column;
        // border-right 1px solid #FFF
        // border 1px solid #FFF
        // margin-bottom: 10px;

        p {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 40px;
          text-align: center;
        }

        .content {
          border-top: 1px dashed #FFF;
        }

        .indicatorName {
          /*color: #4cd964;*/
        }
      }
    }
  }
}

.w240 {
  width: 240px;
}

.w500 {
  width: 500px;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="stylus">
.page-content {
  .el-steps--simple {
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__label {
    color: #fff;
    font-size: 16px;
  }
}
</style>
